.center{width:25%;margin:10px auto}.main-div{height:30vh;display:flex;justify-content:center;align-items:center}.nolist{list-style:none}
/*# sourceMappingURL=analysis-details.component-B7TJZA5Y.css.map */
